import { render, staticRenderFns } from "./FreeHands.vue?vue&type=template&id=0e2a2305"
import script from "./FreeHands.vue?vue&type=script&lang=js"
export * from "./FreeHands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports